import React from 'react';

import { HStack, Text, Button, Flex, Link } from '@chakra-ui/react';

import { AdminSection } from './AdminSection';
import { NewNavSearch } from './NewNavSearch';
import { IAuth } from '../../../Auth/types/auth';
import { useIsMobile } from '../../../hooks';
import { CollectionIcon } from '../../../Icons/CollectionIcon';
import { useModalContext } from '../../../ModalProvider';
import { useModalStore } from '../../../ModalProvider/stores/modal';
import { EModalContent } from '../../../ModalProvider/types/modalContent';
import { EColor } from '../../../Theme';
import { tracker } from '../../../utilities/tracker';
import { getLink } from '../../utils/monolithUrls';

export interface INewHeaderActionsProps {
  auth?: IAuth;
  isInitializing: boolean;
  enableCollections?: boolean;
}

export function NewHeaderActions({
  auth,
  isInitializing,
  enableCollections,
}: INewHeaderActionsProps) {
  const modalStore = useModalStore();
  const { fanaticsCollectBaseUrl } = useModalContext();
  const { profile } = auth || {};
  const isMobile = useIsMobile('sm');
  const isLg = useIsMobile('lg');

  const track = (sectionClicked: string) => {
    tracker.track('Navigation Click', {
      replatformed: false,
      sectionClicked,
    });
  };

  const onLoginClick = () => {
    track('Login');
    modalStore.navigate({
      name: EModalContent.COLLECT_LOGIN,
      redirectUrl: window.location.href,
    });
  };

  const collectionUrl = getLink(
    fanaticsCollectBaseUrl,
    enableCollections ? 'collection' : 'vault'
  );

  const onCollectionClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    track('Collection');
    if (!profile) {
      e.preventDefault();
      modalStore.navigate({
        name: EModalContent.COLLECT_LOGIN,
        redirectUrl: collectionUrl,
      });
    }
  };

  if (isInitializing) {
    return null;
  }

  return (
    <HStack alignItems="center" justify="flex-end" spacing={4}>
      {profile ? (
        <Flex alignItems="center" gap="16px">
          {/* Collection Link - visible on md and above */}
          {!isMobile && (
            <Link
              _hover={{ textDecoration: 'none' }}
              alignItems="center"
              display="flex"
              gap="6px"
              href={collectionUrl}
              onClick={onCollectionClick}
            >
              <CollectionIcon height="20px" width="20px" />
              <Text fontSize="16px" fontWeight="bold">
                Collection
              </Text>
            </Link>
          )}

          {/* Admin button - visible on lg and above */}
          {!isLg && profile?.isAdmin && <AdminSection enableNewNav />}
        </Flex>
      ) : (
        <HStack align="center" justify="flex-end" spacing={2}>
          {isMobile && <NewNavSearch triggerButtonOnly />}
          <Button
            backgroundColor={EColor.White}
            borderColor={EColor.Black}
            borderWidth="1px"
            fontSize="12px"
            fontWeight="bold"
            height="32px"
            paddingX="12px"
            size="sm"
            textTransform="none"
            onClick={onLoginClick}
          >
            Log in
          </Button>
        </HStack>
      )}
    </HStack>
  );
}
